import styled from 'styled-components';
import * as React from 'react';

import { Line } from '../ui/divider/Line';
import { H1 } from './HeaderTitle';
import { Container } from './Container';
import { Maybe } from '../../../client/types/generated/types';
import { SectionTextContainer } from './SectionTextContainer';

// Portal news side
export const SectionInfoStyle = styled.div<any>`
  background-color: ${({ theme, hidebackground }) =>
    hidebackground ? 'transparent' : theme.colors.redwine};
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: ${({ title }) => (title ? '3em 1em 3em 1em' : '1em')};

  h2 {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.white};
    margin-top: 2em;
    width: 100%;
    max-width: 33em;
    text-align: center;
    font-weight: 300;
    padding: 0 30px;
  }
  .date {
    margin-bottom: 2em;
  }
  .ingress {
    p {
      font-size: 22px;
      width: 100%;
      max-width: 41em;
      margin: 0;
      padding: 0;
      text-align: center;
    }
  }
`;

export const SectionInfoNarrow: React.FC<{
  date?: string;
  title?: Maybe<string> | undefined;
  ingress?: Maybe<string> | undefined;
  hidedivider?: boolean;
  info?: Maybe<string> | undefined;
  hidebackground?: boolean;
  link?: string;
  styleInfo?: any;
  classNameInfo?: string;
  style?: any;
}> = ({
  date,
  title,
  hidedivider,
  ingress,
  info,
  hidebackground,
  children,
  link,
  styleInfo,
  style,
  classNameInfo,
}) => {
    return (
      <Container>
        <SectionInfoStyle
          title={title}
          hidebackground={hidebackground}
          style={style}
        >
          {date ? <p className="date">{date}</p> : null}
          {title ? <H1>{title}</H1> : null}
          {!hidedivider ? (
            <Line style={{ marginTop: '-4px', marginBottom: '14px' }} />
          ) : null}
          {ingress ? (
            <p
              className="ingress"
              dangerouslySetInnerHTML={{ __html: ingress }}
            />
          ) : null}
          {info ? (
            <SectionTextContainer
              style={styleInfo}
              className={classNameInfo}
              text={info}
            />
          ) : null}
          {children}
          {link ? <a href={link}>Les mer</a> : null}
        </SectionInfoStyle>
      </Container>
    );
  };
